import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { getAdminFacingApiErrorMessage } from "../../utils/functions/api-errors";

interface BannerQueryFeedbackProps {
  isError: boolean;
  isFetching: boolean;
  hasData: boolean;
  error: unknown;
  errorFallback?: string;
  onRetry: () => void;
}

export const BannerQueryFeedback = ({ isError, isFetching, hasData, error, onRetry, errorFallback = "No se pudieron cargar los banners." }: BannerQueryFeedbackProps) => {
  if (isError) {
    return (
      <div className="flex flex-wrap align-items-center gap-3 mb-3" role="alert">
        <Message severity="error" text={getAdminFacingApiErrorMessage(error, errorFallback)} />
        <Button label="Reintentar" icon="pi pi-refresh" outlined severity="secondary" onClick={onRetry} loading={isFetching} disabled={isFetching} />
      </div>
    );
  }
  return isFetching ? (
    <div role="status" className="text-600 text-sm mb-3">
      <i className="pi pi-spin pi-spinner mr-2" aria-hidden="true" />
      {hasData ? "Actualizando…" : "Cargando…"}
    </div>
  ) : null;
};
